'use client';
import Link from 'next/link';

export const TalkToSupport = () => {
    return (
        <div className='text-center mt-3'>
            <h2 className='p-0 m-0 text-xs' style={{ color: 'rgb(12, 50, 100)' }}>
                We believe in building lasting relationships through trust, quality, and reliability.<br />
                Our dedicated support team is always here to assist you—ensuring a smooth and satisfying experience at every step.</h2>
            <p className='text-teal-500 mb-5'>Even beyond warranty, we offer support and replacement options—so you can continue with a reliable, like-new device.</p>
            <Link
                href="/support"
                className='text-teal-500 surface-10 p-3 border-1 border-10 border-round-sm no-underline'
            >
                Talk to Our Support Team
            </Link>
        </div>
    )
}
